<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Profits Details Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      total_buying: 0,
      total_selling: 0,
      total_discount:0,
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Profits Details Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Profits Details Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: 'PRODUCT',
        },
        {
          key: "qty",
          sortable: true,
          label: 'QUANTITY',
        },
        {
          key: "BPrice_no",
          sortable: true,
          label: 'UNIT BUYING PRICE',
        },
        {
          key: "total_bprice",
          sortable: true,
          label: 'TOTAL BUYING PRICE',
        },
        {
          key: "SPrice_no",
          sortable: true,
          label: 'UNIT SELLING PRICE',
        },
        {
          key: "total_price",
          sortable: true,
          label: 'TOTAL SELLING PRICE',
        },
        {
          key: "sale.sale_date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "profit",
          sortable: true,
          label: "PROFIT",
        }
      ],
      json_fields: {
        PRODUCT: "product",
        QUANTITY: "qty",
        UNIT_BUYINGPRICE: "BPrice",
        TOTAL_BUYINGPRICE: "total_bpriceno",
        UNIT_SELLINGPRICE: "SPrice",
        TOTAL_SELLINGPRICE: "total_priceno",
        PROFIT: "profit",
        DATE: "sale.sale_date",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      details: {
            saledata: this.$route.params.date,
            period: this.$route.params.period,
          },
    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("sales", ["SaleDetails"]),
    ...mapGetters("auth", ["business","branch"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.SaleDetails ? this.SaleDetails.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.SaleDetails ? this.SaleDetails.length : 1;
  },  
  methods: {
    ...mapActions({      
        fetchSalesDetails: "sales/fetchSalesDetails",
        FetchGeneralSettings: "setting/fetchGeneralSettings", 
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  updated() {
    let total_buying = 0;
    let total_selling = 0;
    let total_discount = 0;
      // let total_paid = 0;
      if(this.SaleDetails){
        this.SaleDetails.forEach((item)=>{
          total_buying = total_buying+parseInt(item.total_bprice.replaceAll(/\D/g, ""));
          total_selling = total_selling+parseInt(item.total_priceno);
          total_discount = total_discount+parseInt(item.discount);
        });
        this.total_buying = total_buying;
        this.total_selling = total_selling;
        this.total_discount = total_discount;
      }
  },
  watch: {
    SaleDetails(newValue){
        if(newValue == true){
        this.fetchSalesDetails(this.details);
        }
    }
  },
  created() {
    this.fetchSalesDetails(this.details);
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">Profits Details Report</h3>
              </div>
              <div class="col-md-3" align="right">
                  <b-button @click="$router.go(-1)" variant="warning"><i class="fa fa-undo"></i> Back</b-button>
              </div>
            </div>            
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                  class="btn btn-primary mt-4"
                  :data="SaleDetails"
                  :fields="json_fields"
                  :worksheet="'SALE DETAILS REPORT EXPORTED ON' + currentdate"
                  type="csv"
                  :name="'Saledetails_export' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-file-excel"></i>
                </download-excel>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="SaleDetails?SaleDetails:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>           
              </b-table>
              <div class="row">
                  <div class="col-md-3">
                    <h5>Total Buying Price: <span class="text-danger">{{total_buying.toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Selling Price: <span class="text-danger">{{total_selling.toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Discount: <span class="text-danger">{{total_discount?total_discount.toLocaleString():0}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Profit: <span class="text-danger">{{(total_selling-(total_buying+total_discount)).toLocaleString()}}</span></h5>
                  </div>
                </div>
            </div>
            <Loader  v-if="!SaleDetails"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
